import { notification } from 'antd';
import { IntlFormatters } from 'react-intl';

class WebWorker {
  onmessage: ((this: Worker, ev: MessageEvent) => any) | null = (): void => {};
  postMessage: Function = (): void => {};
  terminate: Function = (): void => {};

  constructor(worker: any) {
    const code = worker.toString();
    const blob = new Blob(['(' + code + ')()']);
    return new Worker(URL.createObjectURL(blob));
  }
}

interface request_param {
  url: string;
  datacenter_name?: string;
  formatMessage?: IntlFormatters['formatMessage'];
  history: any;
  method?: number;
  body?: any;
  func?: Function;
  warning?: boolean;
  is_config?: 1;
}

const http_worker = (): void => {
  const fetch_request = (param: request_param) => {
    const { url, method = 0, body } = param;
    const type = ['GET', 'POST', 'PUT', 'DELETE', 'PATCH'][method];
    const init: RequestInit = {
      method: type,
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'include'
    };
    if (body) {
      init.body = JSON.stringify(body);
    }
    return fetch(url, init);
  };
  onmessage = (e: MessageEvent) => {
    const params: request_param = e.data;
    fetch_request(params).then((response: Response) => {
      const status = response.status;
      if (typeof response.json === 'function') {
        response
          .json()
          .then((json: any) => {
            if (json.services) {
              let items_new = {};
              json.services.items?.forEach((obj: any) => {
                Object.entries(obj).forEach(([key, value]: [string, unknown]) => {
                  const service = Object.values(value as object)[0];
                  obj[key] = { externalUrl: service.externalAddress, targetPort: service.targetPort };
                });
                items_new = Object.assign(items_new, obj);
              });
              json = items_new;
            }
            // @ts-ignore
            postMessage({ status, data: json });
          })
          .catch(() => {
            // @ts-ignore
            postMessage({ status, data: {} });
          });
      } else {
        // @ts-ignore
        postMessage({ status, data: {} });
      }
    });
  };
};
// 按需以对象形式传入参数 url（必填）、method、body
export const worker_fetch = (param: request_param) => {
  const { func, url } = param;
  param.url = window.location.origin + url;
  const { formatMessage, history } = param;
  func && delete param.func;
  delete param.formatMessage;
  delete param.history;
  return new Promise((resolve) => {
    const worker = new WebWorker(http_worker);
    worker.onmessage = (e: MessageEvent) => {
      const { data, status } = e.data;
      if (status > 299 && formatMessage && history) {
        if (data.message) {
          notification.warning({
            message: formatMessage({ id: 'warning' }),
            description: data.message
          });
        }
      } else {
        if (func && 200 <= status && 299 >= status) {
          func(data.items || data.resources || data.resource || data);
        }
      }
      resolve(e.data);
      worker.terminate();
    };
    param.func && delete param.func; // 不能传入worker worker不支持function传入
    worker.postMessage(param);
  });
};
